import { render } from "./YoutubeVideo.vue?vue&type=template&id=48aae200&scoped=true"
import script from "./YoutubeVideo.vue?vue&type=script&lang=js"
export * from "./YoutubeVideo.vue?vue&type=script&lang=js"

import "./YoutubeVideo.vue?vue&type=style&index=0&id=48aae200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48aae200"]])

export default __exports__